// components/LogoGallery.jsx

const LogoGallery = ({ gallery = [] }) => {
  if (!gallery.length) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center justify-center gap-6">
      {gallery.map((url, index) => {
        return (
          <div key={index} className="flex items-center justify-center">
            <img
              src={url}
              alt="utpl"
              className="h-16 w-auto object-contain grayscale hover:grayscale-0 transition duration-300"
            />
          </div>
        );
      })}
    </div>
  );
};

export default LogoGallery;
